import './style.scss'
import { CommunityData } from '../../server/types'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { LazyLoadImage } from 'react-lazy-load-image-component'

interface AppCommunityResultProfileProps {
	profile: CommunityData
}

function AppCommunityResultProfile({profile}: AppCommunityResultProfileProps) {
	
	return (
		<div
			className="app-community-profile-wrap"
		>
			<a
				href={`${PAGE_URLS.APP_COMMUNITY}?id=${profile.id}`}
				aria-label={`Visit the profile page for Community ${profile.community_name}`}
			>
				<LazyLoadImage
					className='app-seach-result-profile-img'
					// src={'/imgs/temp/community/temp-icon.png'}
					src={profile.community_icon_img}
					alt='Community Profile'
					loading="lazy"
					fetchPriority='high'
				/>
			</a>
			<div
				className='app-community-item-name-overlay'
			>
				<div className='app-community-item-name'>{profile.community_name}</div>
			</div>
		</div>
	)
}

export default AppCommunityResultProfile
